import { render } from "./followersModal.vue?vue&type=template&id=4651aee0"
import script from "./followersModal.vue?vue&type=script&lang=js"
export * from "./followersModal.vue?vue&type=script&lang=js"
script.render = render

export default script